import { render, staticRenderFns } from "./DialogNewSiteLayout.vue?vue&type=template&id=31a5641e&"
import script from "./DialogNewSiteLayout.vue?vue&type=script&lang=js&"
export * from "./DialogNewSiteLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports